import { render, staticRenderFns } from "./user_profile_basic.vue?vue&type=template&id=eaa467dc&scoped=true&"
import script from "./user_profile_basic.vue?vue&type=script&lang=ts&"
export * from "./user_profile_basic.vue?vue&type=script&lang=ts&"
import style0 from "./user_profile_basic.vue?vue&type=style&index=0&id=eaa467dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eaa467dc",
  null
  
)

export default component.exports